import textStyles from "../constants/textStyles";

/* eslint-disable sort-keys */
export default {
    Tabs: {
        parts: [
            "root",
            "tab",
            "tablist",
            "tabpanel",
            "indicator"
        ],
        baseStyle: {},
        sizes: {},
        variants: {
            default: {
                tablist: {
                    borderBottom: "1px solid",
                    borderColor: "secondary.100"
                },
                tab: {
                    ...textStyles.p2,
                    "borderBottom": "2px solid",
                    "borderColor": "transparent",
                    "mb": "-1px",
                    "mr": "10",
                    "px": "0",
                    "color": "secondary.900",
                    "_selected": {
                        borderColor: "primary.400",
                        fontWeight: "bold"
                    },
                    "&:first-of-type": {
                        ml: 0
                    },
                    "_focus": {
                        boxShadow: "none"
                    }
                },
                tabpanel: {
                    p: 0
                }
            }
        },
        defaultProps: {
            variant: "default"
        },
    }
};
